// extracted by mini-css-extract-plugin
export var divider = "_er-7";
export var itemsToggle = "_er-8";
export var mergeModal = "_er-1";
export var optionCard = "_er-4";
export var radioGroup = "_er-6";
export var radioOption = "_er-0";
export var selected = "_er-5";
export var shipmentOptions = "_er-2";
export var tableOptions = "_er-3";